import { Component, OnInit, input } from "@angular/core";
import { CustomTranslateService } from "../services/custom-translate.service";
import { BrandingService } from "../../../modules/branding/providers/branding.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { LanguageMapper } from "../models/translation-mapper";
import { NgClass, AsyncPipe } from "@angular/common";
import { FormsModule } from "@angular/forms";

@Component({
    selector: "app-translation",
    templateUrl: "./translation.component.html",
    styleUrls: ["./translation.component.scss"],
    imports: [
    NgClass,
    FormsModule,
    AsyncPipe
],
})
export class TranslationComponent implements OnInit {
    readonly cssClass = input<string>(undefined);
    public brandingSettings$: Observable<string[]>;
    public languageSelected;

    constructor(
        private customTranslateService: CustomTranslateService,
        private brandingService: BrandingService
    ) {
        this.brandingSettings$ = this.brandingService
            .getBrandingSettingsFromStore()
            .pipe(map(({lang}) => lang?.map(lang => LanguageMapper.languageToDisplayLanguage(lang)) ?? []));
        this.languageSelected = this.customTranslateService.getLangFromStore();
    }

    ngOnInit(): void {
        this.customTranslateService
            .getLangFromStore()
            .pipe(map(defaultValue => LanguageMapper.languageToDisplayLanguage(defaultValue)))
            .subscribe((languageSelected) => this.languageSelected = languageSelected);
    }

    selectLanguage(): void {
        this.customTranslateService.changeLang(
            LanguageMapper.displayLanguageToLanguage(this.languageSelected)
        );
    }
}
